import { render } from "./RiWidgetIam.vue?vue&type=template&id=0aa3cff4"
import script from "./RiWidgetIam.vue?vue&type=script&lang=js"
export * from "./RiWidgetIam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiWidgetIam.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aa3cff4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aa3cff4', __exports__)) {
    api.reload('0aa3cff4', __exports__)
  }
  
  module.hot.accept("./RiWidgetIam.vue?vue&type=template&id=0aa3cff4", () => {
    api.rerender('0aa3cff4', render)
  })

}


export default __exports__